import { render, staticRenderFns } from "./processDashboard.vue?vue&type=template&id=5811312a&scoped=true"
import script from "./processDashboard.vue?vue&type=script&lang=js"
export * from "./processDashboard.vue?vue&type=script&lang=js"
import style0 from "./processDashboard.vue?vue&type=style&index=0&id=5811312a&prod&scoped=true&lang=css"
import style1 from "./processDashboard.vue?vue&type=style&index=1&id=5811312a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811312a",
  null
  
)

export default component.exports